import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const BelgiumLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'be',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Belgium',
  SHORT_NAME: 'BE',

  DISPLAY_COUNTRY: 'Belgium',

  LANGUAGES: {
    EN: 'en',
    FR: 'fr',
    NL: 'nl',
  },

  [BRAND_LIST.UQ]: {
    [Languages.NL]: {
      LANGUAGE_CODE: 'nl',
      DISPLAY_NAME: 'Belgium (Dutch)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/be/nl',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/be/nl/',
      CONTACT_US_URL: 'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=nl_NL',
      TERMS_OF_USE_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=nl_NL&c=category_uq_be_nl%3AUQBE_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=nl_NL&c=category_uq_be_nl%3AUQBE_C7_2',
      AREAS: {
        '1': 'Baden-Württemberg',
        '2': 'Bayern',
        '3': 'Berlin',
        '4': 'Brandenburg',
        '5': 'Bremen',
        '6': 'Hamburg',
        '7': 'Hessen',
        '8': 'Niedersachsen',
        '9': 'Mecklenburg-Vorpommern',
        '10': 'Nordrhein-Westfalen',
        '11': 'Rheinland-Pfalz',
        '12': 'Saarland',
        '13': 'Sachsen',
        '14': 'Sachsen-Anhalt',
        '15': 'Schleswig-Holstein',
        '16': 'Thüringen',
      },
    },
    [Languages.FR]: {
      LANGUAGE_CODE: 'fr',
      DISPLAY_NAME: 'Belgium (french)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/be/fr',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/be/fr/',
      CONTACT_US_URL: 'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=fr',
      TERMS_OF_USE_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=fr&c=category_uq_be_nl%3AUQBE_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=fr&c=category_uq_be_nl%3AUQBE_C7_2',
      AREAS: {
        '1': 'Baden-Württemberg',
        '2': 'Bayern',
        '3': 'Berlin',
        '4': 'Brandenburg',
        '5': 'Bremen',
        '6': 'Hamburg',
        '7': 'Hessen',
        '8': 'Niedersachsen',
        '9': 'Mecklenburg-Vorpommern',
        '10': 'Nordrhein-Westfalen',
        '11': 'Rheinland-Pfalz',
        '12': 'Saarland',
        '13': 'Sachsen',
        '14': 'Sachsen-Anhalt',
        '15': 'Schleswig-Holstein',
        '16': 'Thüringen',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'nl',
      DISPLAY_NAME: 'Belgium (English)',
      CONTACT_US_URL: 'https://faq-be.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/be/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/be/en/',
      TERMS_OF_USE_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=en_US&c=category_uq_be_nl%3AUQBE_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-be.uniqlo.com/pkb_Home_UQ_BE?l=en_US&c=category_uq_be_nl%3AUQBE_C7_2',
      AREAS: {
        '1': 'Baden-Württemberg',
        '2': 'Bayern',
        '3': 'Berlin',
        '4': 'Brandenburg',
        '5': 'Bremen',
        '6': 'Hamburg',
        '7': 'Hessen',
        '8': 'Niedersachsen',
        '9': 'Mecklenburg-Vorpommern',
        '10': 'Nordrhein-Westfalen',
        '11': 'Rheinland-Pfalz',
        '12': 'Saarland',
        '13': 'Sachsen',
        '14': 'Sachsen-Anhalt',
        '15': 'Schleswig-Holstein',
        '16': 'Thüringen',
      },
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 50.4953224,
    INITIAL_LONGITUDE: 3.1471068,
    INITIAL_ZOOM: 6,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default BelgiumLocale
